import React, { useContext, useEffect } from "react";
import { PageTitle } from "../../../_metronic/layout/core";
import { PurchaseEntryStep1Form } from "./PurchaseEntryStep1Form";
import BedRockContext from "../../BedRockContext";

export function PurchaseEntryStep1Page() {
    const myData = useContext(BedRockContext);

    // Reset toolbar buttons when entering this page
    useEffect(() => {
        myData.setBaseData({ toolBarButtons: [] });
    }, []);

    const breadcrumbs = [
        {
            title: "Home",
            path: "/dashboard",
            isSeparator: false,
            isActive: false,
        },
        {
            title: "",
            path: "",
            isSeparator: true,
            isActive: false,
        },
        {
            title: "Purchases",
            path: "/purchases-list",
            isSeparator: false,
            isActive: false,
        },
        {
            title: "",
            path: "",
            isSeparator: true,
            isActive: false,
        },
    ];

    return (
        <>
            <PageTitle breadcrumbs={breadcrumbs}>New Purchase - Vehicle Entry (Step 1)</PageTitle>
            <PurchaseEntryStep1Form />
        </>
    );
}
